import { combineReducers } from 'redux'
import ncart from './ncart'
import nshipping from "./shipping";
import npayment from './payment';
import nuser from "./user";
import nresult from "./result";


export default combineReducers({
  ncart,
  nshipping,
  npayment,
  nuser,
  nresult,
})